module.exports = __webpack_public_path__ + "img/pijltje-rechts-rood.35e9fd6f6d5675211e0bfd9d4521f5cc.svg";